import { z } from 'zod';
import { axiosInstance } from '@/utils/libs/axios';
import { downloadFile } from '@/utils/libs/fileUtil';

const reportValueSchema = z.object({
  total: z.number(),
  percentage: z.number(),
});

export const reportSchema = z.object({
  passed_percentage: z.number(),
  total_test_case: z.number(),
  status: z.object({
    blocked: reportValueSchema,
    failed: reportValueSchema,
    hold: reportValueSchema,
    in_progress: reportValueSchema,
    passed: reportValueSchema,
    retest: reportValueSchema,
    untested: reportValueSchema,
  }),
});

// 2. Gunakan axiosInstance untuk get API
export const getProjectOverview = async (
  projectId: string, 
  params?: { release_id?: string; test_run_id?: string; start_date?: string; end_date?: string }
) => {
  const response = await axiosInstance.get(`/api/report/overview/${projectId}`, { params });
  return response.data?.data;
};

// 3. Gunakan axiosInstance juga untuk download, agar token ikut terkirim
export const downloadReportExport = async (
  projectId: string,
  params?: { release_id?: string; test_run_id?: string; start_date?: string; end_date?: string }
) => {
  const response = await axiosInstance.get(`/api/report/export/${projectId}`, {
    params,
    responseType: 'blob', 
  });
  
  downloadFile(response.data, `QA_Report_${projectId}.xlsx`);
};